import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LogoutGuardService } from '@app/modules/auth/guard/logout-guard.service';
import { ThemeModule } from '@theme/theme.module';
import { NbCardModule } from '@nebular/theme';
// import { NbCardModule, NbDialogModule } from '@nebular/theme';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AccountService, CompanyService, Toaster } from '@app/services';
import { AuthRoutingModule } from './auth-routing.module';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AuthComponent } from './layout/auth.component';
import { AuthPopupComponent } from './modals/auth-popup/auth-popup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';


const components = [AuthComponent, LoginComponent, LogoutComponent, ForgotPasswordComponent, ResetPasswordComponent];

@NgModule({
  imports: [AuthRoutingModule,
    CommonModule,
    FormsModule,
    ThemeModule,
    NbCardModule,
    MatTooltipModule,
    MatTabsModule,
    MatDialogModule,
  ],
  providers: [AccountService, CompanyService, Toaster, LogoutGuardService],
  declarations: [...components, AuthPopupComponent],
  entryComponents: [AuthPopupComponent, LoginComponent],
})
export class AuthModule {
}
